var exports = {
  "l": "xa15a2ab7--f71df5--reason",
};

module.exports = exports;
